/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Google_Play_Services_UnavailableInputs */

const en_mobile_google_play_services_unavailable = /** @type {(inputs: Mobile_Google_Play_Services_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Services unavailable`)
};

const es_mobile_google_play_services_unavailable = /** @type {(inputs: Mobile_Google_Play_Services_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Services no está disponible`)
};

/**
* | output |
* | --- |
* | "Google Play Services unavailable" |
*
* @param {Mobile_Google_Play_Services_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_google_play_services_unavailable = /** @type {((inputs?: Mobile_Google_Play_Services_UnavailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Google_Play_Services_UnavailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_google_play_services_unavailable(inputs)
	return en_mobile_google_play_services_unavailable(inputs)
});